<template>
  <div class="row">
    <div class="col-sm-3">
      <SidebarComponent></SidebarComponent>
    </div>
    <div class="col-sm-9">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import SidebarComponent from "./SidebarComponent";
//import axios from "axios";
//import {getUserInfoById} from '../components/backIeasis/usuario';
import { queryIEASIS } from "./backIeasis/dbContextConexion";



export default {
  name: "DashboardComponent",
  components: {
    SidebarComponent,
  },
  data() {
    return {
      usuarioActivo: {},
    };
  },
  

  async mounted() {
    
    /*
    console.log(sessionStorage.getItem("id"), sessionStorage.getItem("perfil"),  sessionStorage.getItem("usuario"))
    
    if (
      !sessionStorage.getItem("id") || 
      !sessionStorage.getItem("perfil") || 
      !sessionStorage.getItem("usuario")) 
      sessionStorage.getItem("id") == undefined || 
      sessionStorage.getItem("perfil") == undefined || 
      sessionStorage.getItem("usuario") == undefined 
      {
     console.log('vacios')
    }
     */
      

    //const res = await getUserInfoById(sessionStorage.getItem[0]("id"))
    const query = "SELECT a.*,b.perfil,b.descripcion perfil_descripcion FROM usuarios a INNER JOIN perfiles b ON a.idperfil  = b.idperfil where idusuario=" + sessionStorage.getItem("id")
    const res1 = await queryIEASIS(query)
    const res = res1[0];


    if (res) {
      console.log('DASHBOARD PRUEBA', res); this.usuarioActivo = res;
      sessionStorage.setItem("perfil",this.usuarioActivo.perfil);
      
    } else {
      console.log('no pude leer')
    }
    /*
    axios
      .post(process.env.VUE_APP_URL + '/usuarios/iealogin', {
        email: gCuenta,
      })
        */


  },
};
</script>
